export default __webpack_public_path__ + "/dist/images/image5.de81ad9bd165ef3db3ea69cbd2ca1696.jpg";